import { formatNumbers } from "../../../helpers/functions.tsx";
import { formatAdminFiguresDateLabel } from "../../../helpers/adminFiguresTime.tsx";
import { Transaction } from "../../../models/User";
import React from "react";
interface IDepositWithdrawalDetails {
    transactions: Transaction[];
}

const getTxDate = (tx: any): Date | null => {
    const d = tx.createDate;

    if (!d) return null;

    if (d.toDate) return d.toDate();
    if (d.seconds) return new Date(d.seconds * 1000);
    if (d instanceof Date) return d;

    return new Date(d);
};
export const DepositWithdrawalDetails = (props: IDepositWithdrawalDetails) => {
    const { transactions } = props;

    const total = transactions.reduce((sum, tx) => {
        if (tx.transactionType === 'deposit') return sum + tx.amount;
        if (tx.transactionType === 'withdrawal') return sum - tx.amount;
        return sum;
    }, 0);

    return (
        <>
            <table className="custom-table">
                <thead>
                    <tr>
                        <th>Ticket</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th className="text-end">Amount</th>
                    </tr>
                </thead>

                <tbody>
                    {transactions.map((tx) => {
                        const isDeposit = tx.transactionType === 'deposit';
                        const isWithdrawal = tx.transactionType === 'withdrawal';
                        const amountClass = isDeposit ? 'amount-positive' : isWithdrawal ? 'amount-negative' : '';
                        const date = getTxDate(tx);

                        return (
                            <tr key={tx.id}>
                                <td>{tx.ticket}</td>
                                <td>
                                    {date
                                        ? formatAdminFiguresDateLabel(date, {
                                              month: '2-digit',
                                              day: '2-digit',
                                          })
                                        : ''}
                                </td>
                                <td>{tx.description}</td>
                                <td className="text-end">
                                    <span className={`amount-box ${amountClass}`}>
                                        {isDeposit ? '+ ' : isWithdrawal ? '- ' : '$'}
                                        ${formatNumbers(tx.amount)}
                                    </span>
                                </td>
                            </tr>
                        );
                    })}

                    <tr className="total-row">
                        <td colSpan={3} className="text-end fw-bold">Total :</td>
                        <td className="text-end">
                            <span className={`amount-box ${total > 0 ? 'amount-positive'
                                : total < 0 ? 'amount-negative' : ''}`}>
                                {total > 0 ? '+ $' : total < 0 ? '- $' : '$'}
                                {formatNumbers(total)}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}
